(() => {
  const canvas = document.getElementById('heroFluidGL');
  if (!canvas) return;


  // ---------- WebGL1 ONLY (najbardziej kompatybilne) ----------
  const params = { alpha: true, depth: false, stencil: false, antialias: false, preserveDrawingBuffer: false };
  const gl = canvas.getContext('webgl', params) || canvas.getContext('experimental-webgl', params);
  if (!gl) return;

  const halfFloat = gl.getExtension('OES_texture_half_float');
  const supportLinearFloat = gl.getExtension('OES_texture_half_float_linear');

  gl.disable(gl.DEPTH_TEST);
  gl.disable(gl.STENCIL_TEST);
  gl.disable(gl.BLEND);
  gl.clearColor(0, 0, 0, 1);

  const ext = {
    internalFormat: gl.RGBA,
    internalFormatRG: gl.RGBA,
    formatRG: gl.RGBA,
    texType: halfFloat ? halfFloat.HALF_FLOAT_OES : gl.UNSIGNED_BYTE
  };

  // ---------- Config (subtelny premium) ----------
  const config = {
    TEXTURE_DOWNSAMPLE: 1,
    DENSITY_DISSIPATION: 0.98,
    VELOCITY_DISSIPATION: 0.99,
    PRESSURE_DISSIPATION: 0.8,
    PRESSURE_ITERATIONS: 25,
    CURL: 30,
    SPLAT_RADIUS: 0.005
  };

  // ---------- Pointer ----------
  function Pointer() {
    this.x = 0; this.y = 0;
    this.dx = 0; this.dy = 0;
    this.moved = false;
    this.color = [0.95, 0.86, 0.78]; // złoto
  }
  const pointer = new Pointer();

  // ---------- Shaders ----------
  function compileShader(type, source) {
    const s = gl.createShader(type);
    gl.shaderSource(s, source);
    gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) {
      // jeśli coś padnie, pokaż błąd w konsoli
      console.error(gl.getShaderInfoLog(s));
      throw new Error('Shader compile failed');
    }
    return s;
  }

  class GLProgram {
    constructor(vs, fs) {
      this.uniforms = {};
      this.program = gl.createProgram();
      gl.attachShader(this.program, vs);
      gl.attachShader(this.program, fs);
      gl.linkProgram(this.program);
      if (!gl.getProgramParameter(this.program, gl.LINK_STATUS)) {
        console.error(gl.getProgramInfoLog(this.program));
        throw new Error('Program link failed');
      }

      const count = gl.getProgramParameter(this.program, gl.ACTIVE_UNIFORMS);
      for (let i = 0; i < count; i++) {
        const name = gl.getActiveUniform(this.program, i).name;
        this.uniforms[name] = gl.getUniformLocation(this.program, name);
      }

      this.aPosition = gl.getAttribLocation(this.program, 'aPosition');
    }
    bind() { gl.useProgram(this.program); }
  }

  const baseVertexShader = compileShader(gl.VERTEX_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    attribute vec2 aPosition;
    varying vec2 vUv;
    varying vec2 vL;
    varying vec2 vR;
    varying vec2 vT;
    varying vec2 vB;
    uniform vec2 texelSize;
    void main () {
      vUv = aPosition * 0.5 + 0.5;
      vL = vUv - vec2(texelSize.x, 0.0);
      vR = vUv + vec2(texelSize.x, 0.0);
      vT = vUv + vec2(0.0, texelSize.y);
      vB = vUv - vec2(0.0, texelSize.y);
      gl_Position = vec4(aPosition, 0.0, 1.0);
    }
  `);

  const clearShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    uniform sampler2D uTexture;
    uniform float value;
    void main () { gl_FragColor = value * texture2D(uTexture, vUv); }
  `);

  const displayShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    uniform sampler2D uTexture;
    void main () { gl_FragColor = texture2D(uTexture, vUv); }
  `);

  const splatShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    uniform sampler2D uTarget;
    uniform float aspectRatio;
    uniform vec3 color;
    uniform vec2 point;
    uniform float radius;
    void main () {
      vec2 p = vUv - point.xy;
      p.x *= aspectRatio;
      vec3 splat = exp(-dot(p, p) / radius) * color;
      vec3 base = texture2D(uTarget, vUv).xyz;
      gl_FragColor = vec4(base + splat, 1.0);
    }
  `);

  const advectionShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    uniform sampler2D uVelocity;
    uniform sampler2D uSource;
    uniform vec2 texelSize;
    uniform float dt;
    uniform float dissipation;
    void main () {
      vec2 coord = vUv - dt * texture2D(uVelocity, vUv).xy * texelSize;
      gl_FragColor = dissipation * texture2D(uSource, coord);
    }
  `);

  const divergenceShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    varying vec2 vL;
    varying vec2 vR;
    varying vec2 vT;
    varying vec2 vB;
    uniform sampler2D uVelocity;
    vec2 sampleVelocity (in vec2 uv) {
      vec2 multiplier = vec2(1.0, 1.0);
      if (uv.x < 0.0) { uv.x = 0.0; multiplier.x = -1.0; }
      if (uv.x > 1.0) { uv.x = 1.0; multiplier.x = -1.0; }
      if (uv.y < 0.0) { uv.y = 0.0; multiplier.y = -1.0; }
      if (uv.y > 1.0) { uv.y = 1.0; multiplier.y = -1.0; }
      return multiplier * texture2D(uVelocity, uv).xy;
    }
    void main () {
      float L = sampleVelocity(vL).x;
      float R = sampleVelocity(vR).x;
      float T = sampleVelocity(vT).y;
      float B = sampleVelocity(vB).y;
      float div = 0.5 * (R - L + T - B);
      gl_FragColor = vec4(div, 0.0, 0.0, 1.0);
    }
  `);

  const curlShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    varying vec2 vL;
    varying vec2 vR;
    varying vec2 vT;
    varying vec2 vB;
    uniform sampler2D uVelocity;
    void main () {
      float L = texture2D(uVelocity, vL).y;
      float R = texture2D(uVelocity, vR).y;
      float T = texture2D(uVelocity, vT).x;
      float B = texture2D(uVelocity, vB).x;
      float vorticity = R - L - T + B;
      gl_FragColor = vec4(vorticity, 0.0, 0.0, 1.0);
    }
  `);

  const vorticityShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    varying vec2 vL;
    varying vec2 vR;
    varying vec2 vT;
    varying vec2 vB;
    uniform sampler2D uVelocity;
    uniform sampler2D uCurl;
    uniform float curl;
    uniform float dt;
    void main () {
      float L = texture2D(uCurl, vL).y;
      float R = texture2D(uCurl, vR).y;
      float T = texture2D(uCurl, vT).x;
      float B = texture2D(uCurl, vB).x;
      float C = texture2D(uCurl, vUv).x;
      vec2 force = vec2(abs(T) - abs(B), abs(R) - abs(L));
      force *= 1.0 / length(force + 0.00001) * curl * C;
      vec2 vel = texture2D(uVelocity, vUv).xy;
      gl_FragColor = vec4(vel + force * dt, 0.0, 1.0);
    }
  `);

  const pressureShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    varying vec2 vL;
    varying vec2 vR;
    varying vec2 vT;
    varying vec2 vB;
    uniform sampler2D uPressure;
    uniform sampler2D uDivergence;
    vec2 boundary (in vec2 uv) { return min(max(uv, 0.0), 1.0); }
    void main () {
      float L = texture2D(uPressure, boundary(vL)).x;
      float R = texture2D(uPressure, boundary(vR)).x;
      float T = texture2D(uPressure, boundary(vT)).x;
      float B = texture2D(uPressure, boundary(vB)).x;
      float divergence = texture2D(uDivergence, vUv).x;
      float pressure = (L + R + B + T - divergence) * 0.25;
      gl_FragColor = vec4(pressure, 0.0, 0.0, 1.0);
    }
  `);

  const gradientSubtractShader = compileShader(gl.FRAGMENT_SHADER, `
    precision highp float;
    precision mediump sampler2D;
    varying vec2 vUv;
    varying vec2 vL;
    varying vec2 vR;
    varying vec2 vT;
    varying vec2 vB;
    uniform sampler2D uPressure;
    uniform sampler2D uVelocity;
    vec2 boundary (in vec2 uv) { return min(max(uv, 0.0), 1.0); }
    void main () {
      float L = texture2D(uPressure, boundary(vL)).x;
      float R = texture2D(uPressure, boundary(vR)).x;
      float T = texture2D(uPressure, boundary(vT)).x;
      float B = texture2D(uPressure, boundary(vB)).x;
      vec2 velocity = texture2D(uVelocity, vUv).xy;
      velocity.xy -= vec2(R - L, T - B);
      gl_FragColor = vec4(velocity, 0.0, 1.0);
    }
  `);

  // ---------- FBOs ----------
  let textureWidth, textureHeight;
  let density, velocity, divergence, curl, pressure;

  function createFBO(texId, w, h, internalFormat, format, type, param) {
    gl.activeTexture(gl.TEXTURE0 + texId);
    const texture = gl.createTexture();
    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, param);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, param);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texImage2D(gl.TEXTURE_2D, 0, internalFormat, w, h, 0, format, type, null);

    const fbo = gl.createFramebuffer();
    gl.bindFramebuffer(gl.FRAMEBUFFER, fbo);
    gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture, 0);
    gl.viewport(0, 0, w, h);
    gl.clear(gl.COLOR_BUFFER_BIT);

    return [texture, fbo, texId];
  }

  function createDoubleFBO(texId, w, h, internalFormat, format, type, param) {
    let fbo1 = createFBO(texId, w, h, internalFormat, format, type, param);
    let fbo2 = createFBO(texId + 1, w, h, internalFormat, format, type, param);
    return {
      get first() { return fbo1; },
      get second() { return fbo2; },
      swap() { const t = fbo1; fbo1 = fbo2; fbo2 = t; }
    };
  }

  function initFramebuffers() {
    textureWidth  = gl.drawingBufferWidth  >> config.TEXTURE_DOWNSAMPLE;
    textureHeight = gl.drawingBufferHeight >> config.TEXTURE_DOWNSAMPLE;

    density    = createDoubleFBO(0, textureWidth, textureHeight, ext.internalFormat, gl.RGBA, ext.texType, supportLinearFloat ? gl.LINEAR : gl.NEAREST);
    velocity   = createDoubleFBO(2, textureWidth, textureHeight, ext.internalFormatRG, ext.formatRG, ext.texType, supportLinearFloat ? gl.LINEAR : gl.NEAREST);
    divergence = createFBO(4, textureWidth, textureHeight, ext.internalFormatRG, ext.formatRG, ext.texType, gl.NEAREST);
    curl       = createFBO(5, textureWidth, textureHeight, ext.internalFormatRG, ext.formatRG, ext.texType, gl.NEAREST);
    pressure   = createDoubleFBO(6, textureWidth, textureHeight, ext.internalFormatRG, ext.formatRG, ext.texType, gl.NEAREST);
  }

  // ---------- Fullscreen quad (attrib by name) ----------
  const quadVBO = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, quadVBO);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, -1,1, 1,1, 1,-1]), gl.STATIC_DRAW);

  const quadIBO = gl.createBuffer();
  gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, quadIBO);
  gl.bufferData(gl.ELEMENT_ARRAY_BUFFER, new Uint16Array([0,1,2, 0,2,3]), gl.STATIC_DRAW);

  function blit(program, destination) {
    gl.bindFramebuffer(gl.FRAMEBUFFER, destination);
    gl.bindBuffer(gl.ARRAY_BUFFER, quadVBO);
    gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER, quadIBO);
    gl.vertexAttribPointer(program.aPosition, 2, gl.FLOAT, false, 0, 0);
    gl.enableVertexAttribArray(program.aPosition);
    gl.drawElements(gl.TRIANGLES, 6, gl.UNSIGNED_SHORT, 0);
  }

  // ---------- Programs ----------
  initFramebuffers();
  const clearProgram      = new GLProgram(baseVertexShader, clearShader);
  const displayProgram    = new GLProgram(baseVertexShader, displayShader);
  const splatProgram      = new GLProgram(baseVertexShader, splatShader);
  const advectionProgram  = new GLProgram(baseVertexShader, advectionShader);
  const divergenceProgram = new GLProgram(baseVertexShader, divergenceShader);
  const curlProgram       = new GLProgram(baseVertexShader, curlShader);
  const vorticityProgram  = new GLProgram(baseVertexShader, vorticityShader);
  const pressureProgram   = new GLProgram(baseVertexShader, pressureShader);
  const gradSubProgram    = new GLProgram(baseVertexShader, gradientSubtractShader);

  // ---------- Resize ----------
  function resizeCanvas() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    const rect = canvas.getBoundingClientRect();
    const cw = Math.max(2, Math.floor(rect.width * dpr));
    const ch = Math.max(2, Math.floor(rect.height * dpr));
    if (canvas.width !== cw || canvas.height !== ch) {
      canvas.width = cw;
      canvas.height = ch;
      initFramebuffers();
    }
  }
  window.addEventListener('resize', resizeCanvas);

  // ---------- Splat ----------
  function splat(x, y, dx, dy, color) {
    splatProgram.bind();
    gl.uniform1f(splatProgram.uniforms.aspectRatio, canvas.width / canvas.height);
    gl.uniform2f(splatProgram.uniforms.point, x / canvas.width, 1.0 - y / canvas.height);
    gl.uniform1f(splatProgram.uniforms.radius, config.SPLAT_RADIUS);

    // velocity
    gl.uniform1i(splatProgram.uniforms.uTarget, velocity.first[2]);
    gl.uniform3f(splatProgram.uniforms.color, dx, -dy, 1.0);
    blit(splatProgram, velocity.second[1]);
    velocity.swap();

    // density (kolor)
    gl.uniform1i(splatProgram.uniforms.uTarget, density.first[2]);
    gl.uniform3f(splatProgram.uniforms.color, color[0] * 1.0, color[1] * 0.85, color[2] * 0.75);
    blit(splatProgram, density.second[1]);
    density.swap();
  }

  function normPos(e) {
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX - rect.left) * (canvas.width / rect.width);
    const y = (e.clientY - rect.top) * (canvas.height / rect.height);
    return { x, y };
  }

  canvas.addEventListener('mousemove', (e) => {
    const pos = normPos(e);
    pointer.moved = true;
    pointer.dx = (pos.x - pointer.x) * 10.0;
    pointer.dy = (pos.y - pointer.y) * 10.0;
    pointer.x = pos.x;
    pointer.y = pos.y;
    pointer.color = (Math.random() < 0.7)
  ? [0.95, 0.80 + Math.random()*0.05, 0.40 + Math.random()*0.08]   // złoto
  : [0.92, 0.62 + Math.random()*0.06, 0.75 + Math.random()*0.06];  // pudrowy róż

  }, { passive: true });

  canvas.addEventListener('touchmove', (e) => {
    e.preventDefault();
    const t = e.targetTouches[0];
    if (!t) return;
    const pos = normPos({ clientX: t.clientX, clientY: t.clientY });
    pointer.moved = true;
    pointer.dx = (pos.x - pointer.x) * 10.0;
    pointer.dy = (pos.y - pointer.y) * 10.0;
    pointer.x = pos.x;
    pointer.y = pos.y;
    pointer.color = [0.95, 0.86 + Math.random()*0.04, 0.70 + Math.random()*0.08];
  }, { passive: false });

  // ---------- Loop ----------
  let lastTime = performance.now();

  function update() {
    resizeCanvas();

    const now = performance.now();
    const dt = Math.min((now - lastTime) / 1000, 0.016);
    lastTime = now;

    gl.viewport(0, 0, textureWidth, textureHeight);

    // advect velocity
    advectionProgram.bind();
    gl.uniform2f(advectionProgram.uniforms.texelSize, 1.0 / textureWidth, 1.0 / textureHeight);
    gl.uniform1i(advectionProgram.uniforms.uVelocity, velocity.first[2]);
    gl.uniform1i(advectionProgram.uniforms.uSource, velocity.first[2]);
    gl.uniform1f(advectionProgram.uniforms.dt, dt);
    gl.uniform1f(advectionProgram.uniforms.dissipation, config.VELOCITY_DISSIPATION);
    blit(advectionProgram, velocity.second[1]);
    velocity.swap();

    // advect density
    gl.uniform1i(advectionProgram.uniforms.uVelocity, velocity.first[2]);
    gl.uniform1i(advectionProgram.uniforms.uSource, density.first[2]);
    gl.uniform1f(advectionProgram.uniforms.dissipation, config.DENSITY_DISSIPATION);
    blit(advectionProgram, density.second[1]);
    density.swap();

    // splat
    if (pointer.moved) {
      splat(pointer.x, pointer.y, pointer.dx, pointer.dy, pointer.color);
      pointer.moved = false;
    }

    // curl
    curlProgram.bind();
    gl.uniform2f(curlProgram.uniforms.texelSize, 1.0 / textureWidth, 1.0 / textureHeight);
    gl.uniform1i(curlProgram.uniforms.uVelocity, velocity.first[2]);
    blit(curlProgram, curl[1]);

    // vorticity
    vorticityProgram.bind();
    gl.uniform2f(vorticityProgram.uniforms.texelSize, 1.0 / textureWidth, 1.0 / textureHeight);
    gl.uniform1i(vorticityProgram.uniforms.uVelocity, velocity.first[2]);
    gl.uniform1i(vorticityProgram.uniforms.uCurl, curl[2]);
    gl.uniform1f(vorticityProgram.uniforms.curl, config.CURL);
    gl.uniform1f(vorticityProgram.uniforms.dt, dt);
    blit(vorticityProgram, velocity.second[1]);
    velocity.swap();

    // divergence
    divergenceProgram.bind();
    gl.uniform2f(divergenceProgram.uniforms.texelSize, 1.0 / textureWidth, 1.0 / textureHeight);
    gl.uniform1i(divergenceProgram.uniforms.uVelocity, velocity.first[2]);
    blit(divergenceProgram, divergence[1]);

    // clear pressure
    clearProgram.bind();
    let pressureTexId = pressure.first[2];
    gl.activeTexture(gl.TEXTURE0 + pressureTexId);
    gl.bindTexture(gl.TEXTURE_2D, pressure.first[0]);
    gl.uniform1i(clearProgram.uniforms.uTexture, pressureTexId);
    gl.uniform1f(clearProgram.uniforms.value, config.PRESSURE_DISSIPATION);
    blit(clearProgram, pressure.second[1]);
    pressure.swap();

    // pressure solve
    pressureProgram.bind();
    gl.uniform2f(pressureProgram.uniforms.texelSize, 1.0 / textureWidth, 1.0 / textureHeight);
    gl.uniform1i(pressureProgram.uniforms.uDivergence, divergence[2]);
    pressureTexId = pressure.first[2];
    gl.activeTexture(gl.TEXTURE0 + pressureTexId);

    for (let i = 0; i < config.PRESSURE_ITERATIONS; i++) {
      gl.bindTexture(gl.TEXTURE_2D, pressure.first[0]);
      gl.uniform1i(pressureProgram.uniforms.uPressure, pressureTexId);
      blit(pressureProgram, pressure.second[1]);
      pressure.swap();
    }

    // subtract gradient
    gradSubProgram.bind();
    gl.uniform2f(gradSubProgram.uniforms.texelSize, 1.0 / textureWidth, 1.0 / textureHeight);
    gl.uniform1i(gradSubProgram.uniforms.uPressure, pressure.first[2]);
    gl.uniform1i(gradSubProgram.uniforms.uVelocity, velocity.first[2]);
    blit(gradSubProgram, velocity.second[1]);
    velocity.swap();

    // render
    gl.viewport(0, 0, gl.drawingBufferWidth, gl.drawingBufferHeight);
    displayProgram.bind();
    gl.uniform1i(displayProgram.uniforms.uTexture, density.first[2]);
    blit(displayProgram, null);

    requestAnimationFrame(update);
  }

  // start
  resizeCanvas();
  pointer.x = canvas.width * 0.5;
  pointer.y = canvas.height * 0.55;
  pointer.dx = 0;
  pointer.dy = 0;
  pointer.moved = true;

  update();
})();
